import Vue from 'vue';
import { API_HOST } from '../constants';

export default {
  register(params) {
    return Vue.axios.post(`${API_HOST}/register`, params);
  },
  authenticate(params) {
    return Vue.axios.post(`${API_HOST}/authenticate`, params);
  },
  identity(token) {
    return Vue.axios.get(`${API_HOST}/identity`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  resendActivationMail(email) {
    return Vue.axios.post(`${API_HOST}/resend-activation-mail`, { email });
  },
  activation(code) {
    return Vue.axios.post(`${API_HOST}/activation`, { code });
  },
  sendResetLink(email) {
    return Vue.axios.post(`${API_HOST}/send-reset-link`, { email });
  },
  resetPassword(params) {
    return Vue.axios.post(`${API_HOST}/reset-password`, params);
  },
  refresh() {
    return Vue.axios.post(`${API_HOST}/refresh`);
  },
  updatePassword(params) {
    return Vue.axios.post(`${API_HOST}/update-password`, params);
  },
  uploadAvatar(params) {
    return Vue.axios.post(`${API_HOST}/upload-avatar`, params);
  },
  memberInfo(params) {
    return Vue.axios.post(`${API_HOST}/member-info`, params);
  },
  checkCode(code) {
    return Vue.axios.get(`${API_HOST}/check-code/${code}`);
  },
  getAddresses() {
    return Vue.axios.get(`${API_HOST}/address`);
  },
  newAddress(params) {
    return Vue.axios.post(`${API_HOST}/address`, params);
  },
  adminLogin(params) {
    return Vue.axios.post(`${API_HOST}/admin-login`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/member.js